import { Fragment, type FC, useState, useMemo } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { PortfolioCard, Text } from 'components'

import { projects, resolveLang, portfolioImg, type TPortfolioCategory } from './portfolioCatalog'
import { filters, categoryLabel, heroImage } from './utils'
import styles from './Portfolio.module.scss'

const Portfolio: FC = () => {
  const { i18n } = useTranslation()
  const lang = resolveLang(i18n.language)
  const [activeTab, setActiveTab] = useState<TPortfolioCategory | 'all'>('all')

  const data = useMemo(() => projects.filter(item => activeTab === 'all' || item.category === activeTab), [activeTab])

  return (
    <Fragment>
      <section className={styles.hero}>
        <div className={styles.hero__media} aria-hidden>
          <img src={heroImage} alt='' className={styles.hero__image} />
          <div className={styles.hero__overlay} />
        </div>
        <div className={classNames('container', styles.hero__inner)}>
          <Text text='ourPortfolio' className={styles.hero__eyebrow} />
          <Text text='portfolio' className={styles.hero__title} tagName='h1' />
          <Text text='portfolioSubtitle' className={styles.hero__subtitle} />
        </div>
      </section>

      <div className={styles.page}>
        <div className={classNames('container', styles.controls)}>
          <div className={styles.filters} role='tablist' aria-label='Portfolio filters'>
            {filters.map(filter => (
              <button
                key={filter.key}
                role='tab'
                aria-selected={activeTab === filter.key}
                className={classNames(styles.filter, { [styles.filter_active]: activeTab === filter.key })}
                onClick={() => setActiveTab(filter.key)}
              >
                <Text text={filter.label} />
              </button>
            ))}
          </div>
        </div>

        <div className={classNames('container', styles.gridWrapper)}>
          <div className={styles.grid} key={activeTab}>
            {data.map(item => (
              <PortfolioCard
                key={item.slug}
                to={`/portfolio/${item.slug}`}
                title={item.name[lang] || item.name.am}
                date={item.year}
                backgroundImage={portfolioImg(item.slug, item.cover)}
                tag={item.category ? categoryLabel[item.category] : undefined}
              />
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default Portfolio
